import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "bule_list_page" }
const _hoisted_2 = { class: "main" }

import request from "../../common/request";
import { computed, onMounted } from "vue";
import { ref, reactive } from "vue";
import { langList } from "@/common/lang";
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons-vue'

import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";
import { getLanguage } from "@/common/translate";


export default /*@__PURE__*/_defineComponent({
  __name: 'translations',
  setup(__props) {

const loading = ref(false);
let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
   language.value = 'English'
  langObj.value = langList[language.value]
}
getLang()

const formState = reactive({
  keyword: "",
  category: "",
  skip: 1,
  take: 10,
});
let total = ref(0);
let pagination = computed(() => ({
  total: total.value,
  current: formState.skip,
  pageSize: formState.take,
}));

const handleTableChange = (pagination: any, _filters: any, _sorter: any) => {
  formState.skip = pagination.current;
  formState.take = pagination.pageSize
  search();
};

const categories = ref<any[]>([
  { value: "sensorName", label: "sensorName" },
  { value: "machineName", label: "machineName" },
  { value: "groupName", label: "groupName" },
  { value: "factoryName", label: "factoryName" },
]);

let form: any = ref({
  key: "",
  category: "",
  zh: "",
  en: "",
});

const modalState = reactive({
  visible: false,
  title: langObj.value["新增"],
  confirmLoading: false,
});

const formStateRef = ref();

const dataSource = ref([]);
const columns = [
  {
    title: langObj.value["键"],
    dataIndex: "key",
    align: "center",
  },
  {
    title: langObj.value["中文"],
    dataIndex: "zh",
    align: "center",
  },
  {
    title: langObj.value["英文"],
    dataIndex: "en",
    align: "center",
  },
  {
    title: getLanguage('繁体'),
    dataIndex: "ft",
    align: "center",
  },
  {
    title: langObj.value["分类"],
    dataIndex: "category",
    align: "center",
  },
  {
    title: langObj.value["操作"],
    dataIndex: "act",
    with: 120,
    align: "center",
  }
];

const add = () => {
  formStateRef.value?.clearValidate();
  modalState.title = langObj.value["新增"];
  form.value = {
    key: "",
    category: "",
    zh: "",
    en: "",
  };
  modalState.visible = true;
};

const editThis = (val: any) => {
  formStateRef.value?.clearValidate();
  modalState.title = langObj.value["编辑"];
  form.value = JSON.parse(JSON.stringify(val));

  modalState.visible = true;
};

// 保存
const handleOk = () => {
  formStateRef.value?.clearValidate();
  formStateRef.value
      .validate()
      .then((_: any) => {
        if (form.value.id) {
          request
              .put("/api/translations", form.value)
              .then((res) => {
                if (res) {
                  modalState.visible = false;
                  message.success(getLanguage("操作成功"));
                  search();
                }
              });
        } else {
          request
              .post("/api/translations", form.value)
              .then((res) => {
                if (res) {
                  modalState.visible = false;
                  message.success(getLanguage("操作成功"));
                  search();
                }
              });
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
};

// 删除
const deleteThis = (ev: any) => {
  const config = {
    params: {
      id: ev.id
    },
    headers: {
      requestId: uuidv4(),
    },
  };
  request
      .delete("/api/translations", config)
      .then((res) => {
        if (res) {
          message.success(getLanguage("操作成功"));
          formState.skip = 1
          search();
        } else {
          message.warning("操作失败");
        }
      });
}

// 查询
const search = () => {
  const config = {
    params: formState,
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/translations", config).then((res: any) => {
    if (res) {
      dataSource.value = res.data.list;
      total.value = res.data.count;
    }
  });
};

let isShowDel: any = ref(false)
const getMemberInfo = async () => {
  let result = await request.get("/api/members/info")
  if (result?.data?.admin) {
    isShowDel.value = true
  }
}
let isEditable: any = ref(false)
// 在组件加载完成后执行一些操作
onMounted(async () => {
  request.get("/api/translations/categories").then((res: any) => {
    if (res?.data) {
      categories.value = res.data.map((item: any) => {
        return { value: item, label: item };
      });
    }
  });
  getMemberInfo().catch(() => { })
  search();
});


return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: _unref(language) === 'English' ? _unref(enUS) : _unref(zhCN)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_layout_content, { style: {"padding":"30px 30px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "inline" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: _unref(langObj)['关键词']
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: formState.keyword,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.keyword) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, {
                  label: _unref(langObj)['分类']
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_auto_complete, {
                      value: formState.category,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.category) = $event)),
                      options: categories.value,
                      "allow-clear": "",
                      style: {"min-width":"200px"}
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => {formState.skip = 1; search()})
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(langObj)['搜索']), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    (_unref(isEditable))
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          type: "primary",
                          onClick: add
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_unref(PlusOutlined))
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_unref(langObj)['新增']), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_table, {
                bordered: "",
                emptyText: _unref(langObj)['暂无数据'],
                columns: columns,
                "data-source": dataSource.value,
                pagination: _unref(pagination),
                onChange: handleTableChange,
                loading: loading.value,
                size: "small"
              }, {
                bodyCell: _withCtx(({ column, text, record }) => [
                  (column.dataIndex === 'act')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_unref(isEditable))
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              type: "primary",
                              class: "plft",
                              onClick: ($event: any) => (editThis(record))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(EditOutlined)),
                                _createTextVNode(" " + _toDisplayString(_unref(langObj)['编辑']), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_popconfirm, {
                          title: _unref(langObj)['确定删除此条数据么']+'?',
                          "ok-text": _unref(langObj)['确定'],
                          "cancel-text": _unref(langObj)['取消'],
                          onConfirm: ($event: any) => (deleteThis(record))
                        }, {
                          default: _withCtx(() => [
                            (_unref(isShowDel))
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  style: {"margin-left":"10px"},
                                  type: "primary",
                                  danger: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(DeleteOutlined)),
                                    _createTextVNode(" " + _toDisplayString(_unref(langObj)['删除']), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["title", "ok-text", "cancel-text", "onConfirm"])
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["emptyText", "data-source", "pagination", "loading"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_modal, {
          width: 850,
          maskClosable: false,
          title: modalState.title,
          visible: modalState.visible,
          "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((modalState.visible) = $event)),
          "confirm-loading": modalState.confirmLoading,
          cancelText: _unref(langObj)['取消'],
          okText: _unref(langObj)['确认'],
          onOk: handleOk
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              ref_key: "formStateRef",
              ref: formStateRef,
              model: _unref(form),
              name: "basic",
              autocomplete: "off",
              "label-col": { style: { width: '180px' } }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: _unref(langObj)['键'],
                  name: "key",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _unref(form).key,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).key) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, {
                  label: _unref(langObj)['中文'],
                  name: "zh",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _unref(form).zh,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).zh) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, {
                  label: _unref(langObj)['英文'],
                  name: "en"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _unref(form).en,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).en) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, {
                  label: _unref(getLanguage)('繁体'),
                  name: "ft"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _unref(form).ft,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).ft) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, {
                  label: _unref(langObj)['分类'],
                  name: "category"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_auto_complete, {
                      value: _unref(form).category,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).category) = $event)),
                      options: categories.value
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["title", "visible", "confirm-loading", "cancelText", "okText"])
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})